<template>
  <div class="filter-schedule filter-modal-wrapper mobile-filter-schedule">
    <p class="light-gray">
      {{ $t('common.shedule') }}
    </p>
    <Input
      :value="searchScheduleStr || ''"
      :placeholder="$t('common.shedule')"
      :readonly="true"
      @click.native.stop="show = true"
    />
    <el-dialog
      class="schedule-modal scheduler"
      :visible.sync="show"
      :modal-append-to-body="false"
      :center="true"
      :show-close="false"
      :lock-scroll="true"
    >
      <ModalSchedule @clicked="chooseSchedule" />
    </el-dialog>
  </div>
</template>

<script>
import Input from '~/components/Common/Input'
import ModalSchedule from '~/components/Search/Modals/Schedule'
import ScheduleParserMixin from '~/dependencies/mixins/schedule-parser'

export default {
  name: 'Schedule',
  components: {
    Input,
    ModalSchedule
  },
  mixins: [ScheduleParserMixin],
  data() {
    return {
      show: false
    }
  },
  methods: {
    chooseSchedule() {
      this.show = false
    }
  }
}
</script>

<style scoped></style>
